import * as AssetSlideAction from './actionsType';
import IAssetProfileModal from 'model/IAssetProfileModal';

export const toggleModalState = ({ isOpen, slugParam, isSlidingUp, overlaySlug }: Partial<IAssetProfileModal>) => ({
    type: AssetSlideAction.SET_SLIDE_UP_MODAL_STATE,
    payload: { isOpen, slugParam, isSlidingUp, overlaySlug },
});
